const scrollbarSelectors = {
  elements: {
    scrollbarAttribute: 'data-scrollbar',
    scrollbar: 'data-scrollbar-slider',
    scrollbarSlideFullWidth: 'data-scrollbar-slide-fullwidth',
    scrollbarArrowPrev: '[data-scrollbar-arrow-prev]',
    scrollbarArrowNext: '[data-scrollbar-arrow-next]',
  },
  classes: {
    hide: 'is-hidden',
  },
  times: {
    delay: 200,
  },
};

class NativeScrollbar {
  constructor(scrollbar) {
    this.scrollbar = scrollbar;

    this.arrowNext = this.scrollbar.parentNode.querySelector(scrollbarSelectors.elements.scrollbarArrowNext);
    this.arrowPrev = this.scrollbar.parentNode.querySelector(scrollbarSelectors.elements.scrollbarArrowPrev);

    if (this.scrollbar.hasAttribute(scrollbarSelectors.elements.scrollbarAttribute)) {
      this.init();
      this.resize();
    }

    if (this.scrollbar.hasAttribute(scrollbarSelectors.elements.scrollbar)) {
      this.scrollToVisibleElement();
    }
  }

  init() {
    if (this.arrowNext && this.arrowPrev) {
      this.toggleNextArrow();

      this.events();
    }
  }

  resize() {
    document.addEventListener('theme:resize', () => {
      this.toggleNextArrow();
    });
  }

  events() {
    this.arrowNext.addEventListener('click', (event) => {
      event.preventDefault();

      this.goToNext();
    });

    this.arrowPrev.addEventListener('click', (event) => {
      event.preventDefault();

      this.goToPrev();
    });

    this.scrollbar.addEventListener('scroll', () => {
      this.togglePrevArrow();
      this.toggleNextArrow();
    });
  }

  goToNext() {
    const moveWith = this.scrollbar.hasAttribute(scrollbarSelectors.elements.scrollbarSlideFullWidth) ? this.scrollbar.getBoundingClientRect().width : this.scrollbar.getBoundingClientRect().width / 2;
    const position = moveWith + this.scrollbar.scrollLeft;

    this.move(position);

    this.arrowPrev.classList.remove(scrollbarSelectors.classes.hide);

    this.toggleNextArrow();
  }

  goToPrev() {
    const moveWith = this.scrollbar.hasAttribute(scrollbarSelectors.elements.scrollbarSlideFullWidth) ? this.scrollbar.getBoundingClientRect().width : this.scrollbar.getBoundingClientRect().width / 2;
    const position = this.scrollbar.scrollLeft - moveWith;

    this.move(position);

    this.arrowNext.classList.remove(scrollbarSelectors.classes.hide);

    this.togglePrevArrow();
  }

  toggleNextArrow() {
    setTimeout(() => {
      this.arrowNext.classList.toggle(scrollbarSelectors.classes.hide, Math.round(this.scrollbar.scrollLeft + this.scrollbar.getBoundingClientRect().width + 1) >= this.scrollbar.scrollWidth);
    }, scrollbarSelectors.times.delay);
  }

  togglePrevArrow() {
    setTimeout(() => {
      this.arrowPrev.classList.toggle(scrollbarSelectors.classes.hide, this.scrollbar.scrollLeft <= 0);
    }, scrollbarSelectors.times.delay);
  }

  scrollToVisibleElement() {
    [].forEach.call(this.scrollbar.children, (element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();

        this.move(element.offsetLeft - element.clientWidth);
      });
    });
  }

  move(offsetLeft) {
    this.scrollbar.scrollTo({
      top: 0,
      left: offsetLeft,
      behavior: 'smooth',
    });
  }
}

document.querySelectorAll('[data-link-variant]').forEach(elem => {
  elem.addEventListener('click', function (e) {
    var href = e.target.dataset.href;
    window.location.href = href;
  });
});


document.querySelectorAll('[data-variant-input]').forEach(elem => {
  elem.addEventListener('change', function(e) {
    if(this.options) {
      let selectedOption = this.options[this.selectedIndex];
      if(selectedOption.hasAttribute('data-href')) {
        var href = selectedOption.dataset.href;
        window.location.href = href;
      }
    }
  });
});

function setSliderHeightToMax(slider) {
  slider.cells.forEach(cell => cell.element.style.height = '');
      
  let heights = slider.cells.map(cell => cell.element.offsetHeight),
      max = Math.max.apply(Math, heights);
  
  slider.cells.forEach(cell => cell.element.style.height = max + 'px');
}

var sliders = document.querySelectorAll('[data-grid-carousel]');

sliders.forEach(slider => {
  var flkty = new Flickity( slider, {
    cellAlign: 'left',
    contain: true,
    groupCells: true,
    pageDots: false,
    on: {
      ready: function() {
          setSliderHeightToMax(this);
      }
    }
  });

  window.addEventListener('resize', function(){
    setSliderHeightToMax(flkty);
  });
});

/* SCROLL TO TOP */
document.addEventListener('DOMContentLoaded', function () {
  const scrollTopButton = document.querySelector('[data-scroll-top-button]');
  if (scrollTopButton) {
    scrollTopButton.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    });
    window.addEventListener('scroll', () => {
      scrollTopButton.classList.toggle('is-visible', window.pageYOffset > window.innerHeight);
    });
  }
});


let variantSelectorContainer = document.querySelector('.template-product .product-single__meta .variant-wrapper');
if(variantSelectorContainer) {
  let variantSelector = variantSelectorContainer.querySelector('[' + scrollbarSelectors.elements.scrollbarAttribute + ']');
  if (variantSelector) {
    new NativeScrollbar(variantSelector);
  }
}

function _updateAvailableStates() {
  var form = pdp.querySelector('.product-single__form');
  var variantInputs = pdp.querySelectorAll('.variant-wrapper .variant-input');
  
  variantInputs.forEach( (variant) => {
    variant.classList.remove('soldout');
    variant.classList.remove('unavailable');
  });

  var variantsWrapper = pdp.querySelector('.product-block__variants');
  variantsWrapper.querySelector('.product-single__soldout-badge').classList.add('hide');

  let selectedVariant = '';
  variantsWrapper.querySelectorAll('.variant-wrapper input[type="radio"]:checked').forEach( (option) => {
    selectedVariant = selectedVariant + ' / ' + option.value;
  });
  selectedVariant = selectedVariant.replace(' / ', '');
  console.log(selectedVariant);
  form.querySelectorAll('.product-single__variants--dummy option').forEach( (selectOption) => {
    let optionValue = selectOption.innerHTML.trim();
    if(selectedVariant === optionValue && selectOption.disabled) {
      variantsWrapper.querySelector('.product-single__soldout-badge').classList.remove('hide');
    }
  });
                                                                                      
  variantsWrapper.querySelectorAll('.variant-wrapper').forEach( (option) => {
    let selectPosition = option.dataset.optionPosition;
    let selectedRadio = option.querySelector('input[type="radio"]:checked');
    let selectedValue = selectedRadio.value;

    form.querySelectorAll('.product-single__variants--dummy option').forEach( (selectOption) => {
      let optionValue = selectOption.innerHTML.trim();
      let arrayValues = selectOption.innerHTML.split(' / ');
      var arrayOption = arrayValues[selectPosition - 1];

      // If the option text contains the name of the selected value and it´s disabled then mark it as soldout
      if (arrayOption.trim() === selectedValue && selectOption.disabled) {
        var option1 = arrayValues[0].trim();
        var option2 = null;
        var option3 = null;
        if (arrayValues.length > 2) {
          option2 = arrayValues[1]?.trim();
          option3 = arrayValues[2]?.trim();
        } else {
          option2 = arrayValues[1]?.trim();
        }

        variantsWrapper.querySelectorAll('.variant-wrapper:not([data-option-position="' + selectPosition + '"])').forEach(sibling => {
          var element = sibling.querySelector(`input[type="radio"][value="${option1.replace('"', '\\"')}"]`);
          if (element) element.parentElement.classList.add('soldout');

          if (option2) {
            element = sibling.querySelector(`input[type="radio"][value="${option2.replace('"', '\\"')}"]`);
            if (element) element.parentElement.classList.add('soldout');
          }

          if (option3) {
            element = sibling.querySelector(`input[type="radio"][value="${option3.replace('"', '\\"')}"]`);
            if (element) element.parentElement.classList.add('soldout');
          }
        });
      }
    });

      /*
      if (!found) {
        radio.parentElement.classList.add('unavailable');
      } 
    });*/
  });
}


var pdp = document.querySelector('.template-product');

(function() { 
  
  if(pdp) {
      
    _updateAvailableStates();
  
    pdp.querySelectorAll('.variant-wrapper input[type="radio"]').forEach(radio => {
      radio.addEventListener('change', _updateAvailableStates);
    });
  
    // Hide or show price depending if the Recharge widget is showing or not  
  }

  if(pdp) {

     (function() {
    function handleWidgetAppeared(widgetNode) {
      document.querySelector('.product-block--price').style.display = 'none';

      let initialValue = widgetNode.querySelector('input[name="purchaseOption"]:checked').value;
      console.log(initialValue);
      if(initialValue == 'subscription') {
        document.querySelector('.product__policies').style.display = 'none';
      } else {
        document.querySelector('.product__policies').style.display = 'block';
      }
      
      widgetNode.querySelectorAll('input[name="purchaseOption"]').forEach((e) => {
        e.addEventListener('change', function(radio){ 
          let radioValue = radio.target.value;
          if(radioValue == 'subscription') {
            document.querySelector('.product__policies').style.display = 'none';
          } else {
            document.querySelector('.product__policies').style.display = 'block';
          }
        });
      });
      //document.querySelector('.product__policies').style.display = 'none';
    }

    function handleWidgetDisappeared(widgetNode) {
      document.querySelector('.product-block--price').style.display = 'block';
      document.querySelector('.product__policies').style.display = 'block';
    }

    const shadowHost = document.querySelector('recharge-subscription-widget');

    if (!shadowHost) {
        return;
    }

    // Observe for shadowRoot creation
    const shadowHostObserver = new MutationObserver(function(mutations) {
        mutations.forEach(mutation => {
            if (shadowHost.shadowRoot) {
                shadowHostObserver.disconnect();
                observeShadowRoot(shadowHost.shadowRoot);
            }
        });
    });

    shadowHostObserver.observe(shadowHost, { childList: true });

    // Polling for shadowRoot
    const pollForShadowRoot = setInterval(function() {
        if (shadowHost.shadowRoot) {
            clearInterval(pollForShadowRoot);
            if(shadowHostObserver){
                shadowHostObserver.disconnect();
            }
            observeShadowRoot(shadowHost.shadowRoot);
        }
    }, 50);

    function observeShadowRoot(shadowRoot) {
        const initialWidget = shadowRoot.querySelector('.rc-widget__root');
        if (initialWidget) {
          handleWidgetAppeared(initialWidget);
          
        }

        // Observe the shadow root for rc-widget__root changes
        const config = { childList: true, subtree: true };

        const callback = function(mutationsList, observer) {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    const addedNodes = Array.from(mutation.addedNodes);
                    const removedNodes = Array.from(mutation.removedNodes);

                    addedNodes.forEach(node => {
                        if (node.classList && node.classList.contains('rc-widget__root')) {
                            handleWidgetAppeared(node);
                        }
                    });

                    removedNodes.forEach(node => {
                        if (node.classList && node.classList.contains('rc-widget__root')) {
                            handleWidgetDisappeared(node);
                        }
                    });
                }
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(shadowRoot, config);
    }
})();
  }
})(); 
